import { ospThemes } from "@ospweb/sdk-ui";
import { useEffect, useMemo, useRef } from "react";
import { HistoryProps } from "./types";
import { createDualYAxisLineChart } from "@/src/components/createChart";
import { formatBigNumber } from "@/src/utils";

export const useHistory = ({ history }: Pick<HistoryProps, "history">) => {
  const chartRef = useRef<HTMLDivElement>(null);

  const ticks = useMemo(() => {
    const step = Math.floor(history.XAxis.length / 4);
    const xKeyTicks = [
      history.XAxis[step],
      history.XAxis[step * 2],
      history.XAxis[step * 3],
    ];
    return { xKeyTicks };
  }, [history.XAxis]);

  useEffect(() => {
    if (!chartRef.current) {
      return;
    }
    const result = createDualYAxisLineChart({
      XAxis: history.XAxis,
      YAxis: {
        left: [
          {
            name: "Total value",
            color: ospThemes.colors.content_brand_primary,
            data: history.valueData,
            lineWidth: 2,
            shadow: true,
          },
        ],
      },
      config: {
        el: chartRef.current,
        // Y轴刻度格式化
        // yAxisTickFormatter: percentageFormatter,
        // tooltip 值格式化（用于默认tooltip和Y轴十字线标签）
        tooltipValueFormat: (value: MaybeOrNull<number>) => {
          if (value === null) {
            return "";
          }
          // const percentage = (value * 100).toFixed(2);
          return `$${formatBigNumber(value, {
            precision: 2,
            needFormat: true,
          })}`;
        },
        // 自定义 tooltip HTML 内容（仅接收 x 索引）
        // tooltipFormatter,
      },
      ticks,
    });

    return () => {
      result?.cleanup?.();
    };
  }, [history, ticks]);
  return {
    chartRef,
  };
};
